module.exports = "/packs/images/homepage/involved/get-involved_sprite~0a167e7e3be1fc6d192118fae5b0ca2f.svg";